import { useRef, useCallback, useState } from 'react';

interface DragState {
  x: number;
  y: number;
}

export function useDraggable(initialPosition?: { x?: number; y?: number }) {
  const [pos, setPos] = useState<DragState>({
    x: initialPosition?.x ?? 0,
    y: initialPosition?.y ?? 0,
  });
  const dragging = useRef(false);
  const offset = useRef({ x: 0, y: 0 });

  const onPointerDown = useCallback((e: React.PointerEvent) => {
    // Only drag from the header area (check for data attribute)
    const target = e.target as HTMLElement;
    const header = target.closest('[data-drag-handle]');
    if (!header) return;

    dragging.current = true;
    offset.current = {
      x: e.clientX - pos.x,
      y: e.clientY - pos.y,
    };

    const onMove = (ev: PointerEvent) => {
      if (!dragging.current) return;
      setPos({
        x: ev.clientX - offset.current.x,
        y: ev.clientY - offset.current.y,
      });
    };

    const onUp = () => {
      dragging.current = false;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
    };

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
  }, [pos.x, pos.y]);

  const style: React.CSSProperties = {
    transform: `translate(${pos.x}px, ${pos.y}px)`,
  };

  return { dragStyle: style, onPointerDown };
}
